import { FC } from 'react';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { format } from 'date-fns';
import { Button } from '../ui/Button';
import { cn } from '../../utils/cn';
import { CalendarHeaderProps } from './types';

export const CalendarHeader: FC<CalendarHeaderProps> = ({
  currentDate,
  onPrevious,
  onNext,
  onToday,
  canGoPrevious,
  canGoNext,
}) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <Calendar className="h-5 w-5 text-gray-500 dark:text-slate-400" aria-hidden="true" />
          <h3 className="text-lg font-semibold text-gray-900 dark:text-slate-100">
            {format(currentDate, 'MMMM yyyy')}
          </h3>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onToday}
          className={cn('hidden sm:inline-flex')}
        >
          Today
        </Button>

        <div className="flex items-center border border-gray-200 dark:border-slate-700 rounded-lg">
          <Button
            variant="ghost"
            size="sm"
            onClick={onPrevious}
            disabled={!canGoPrevious}
            aria-label="Previous month"
            className="rounded-r-none border-r border-gray-200 dark:border-slate-700"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onNext}
            disabled={!canGoNext}
            aria-label="Next month"
            className="rounded-l-none"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

CalendarHeader.displayName = 'CalendarHeader';
